// @flow

export const isArrayWithContent = (arr: ?*) =>
    !!arr && Array.isArray(arr) && arr.length > 0;
